export const CONSTRAINT = 'constraint';
export const CONSTRAINT_FOR_SELECTED = 'constraint_for_selected';
export const EXTENSION = 'extension';
export const SETTING = 'setting';
export const CUSTOM_TOOL = 'custom_tool';
export const CONTEXT_MENU = 'context-menu';
export const HOVERED_ELEMENT_SETTINGS = 'hovered-element-settings';
export const SELECTED_ELEMENT_SETTINGS = 'selected-element-settings';
